// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"818":"auth","942":"article"}[chunkId] + "." + {"818":"c9870e63","942":"e8bba0dc"}[chunkId] + ".js";
};